import script from "./DashboardLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardLayout.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardLayout.vue?vue&type=style&index=0&id=44ba0ac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44ba0ac0"]])

export default __exports__